import React from "react";
import { UseModernOrLegacyHook } from "./hooks";
import ModernOrLegacy from "./ModernOrLegacy";
import SelectBrand from "./SelectBrand";
import SelectBookkeeping from "./SelectBookkeeping";
import { DocumentTypeWithoutInvoice, getEsignRoute, getLegacyRoute } from "./utils";

interface Props {
  bookkeepings: server.dto.BookkeepingSmall[]
  brands: server.dto.BrandSmall[]
  modernOrLegacyHook: UseModernOrLegacyHook;
  qs?: string;
  documentType: DocumentTypeWithoutInvoice;
}

const CreateEsign = (props: Props) => {
  const hasOnlyOneBrand = props.brands.length === 1;
  const hasOnlyOneBookkeeping = props.bookkeepings.length === 1;

  const skipMinimalCreationScreen = React.useRef(hasOnlyOneBookkeeping && hasOnlyOneBrand);

  const [selectedBrand, setSelectedBrand] = React.useState<server.dto.BrandSmall>(hasOnlyOneBrand ? props.brands[0] : null);
  const [selectedBookkeeping, setSelectedBookkeeping] = React.useState<server.dto.BookkeepingSmall>(hasOnlyOneBookkeeping ? props.bookkeepings[0] : null);

  const onSave = async () => {
    return window.CoreApi.ESign.Create({
      bookkeepingId: selectedBookkeeping.bookkeepingId,
      brandId: selectedBrand.brandId,
      documentType: props.documentType,
    });
  }

  React.useEffect(() => {
    if (props.modernOrLegacyHook.screen === "minimalCreationScreen" && hasOnlyOneBookkeeping && hasOnlyOneBrand) {
      onSave()
        .then(r => {
          if (!r) return;
          redirectToEsign(r.data.data);
        });
    }
  }, [props.modernOrLegacyHook.screen])

  const redirectToLegacy = () => {
    const qs = props.qs ? `?${props.qs}` : "";
    window.location.href = getLegacyRoute(props.documentType) + qs;
  }

  const redirectToEsign = (itemId: number) => {
    window.location.href = getEsignRoute(props.documentType, itemId);
  }

  return <ModernOrLegacy
    modalTitle={site.currentEnvironment[props.documentType].newLabel}
    useModernOrLegacyHook={props.modernOrLegacyHook}
    redirectToLegacy={redirectToLegacy}
    isLoadingMinimalCreationScreen={skipMinimalCreationScreen.current}
    newLabel={site.currentEnvironment[props.documentType].newLabel}
    sections={[{
      key: "esign",
      type: "regular",
      title: site.currentEnvironment[props.documentType].newLabel,
      fields: [{
        key: "bookkeeping",
        label: RESX.Bookkeeping.resxBookkeeping,
        hidden: hasOnlyOneBookkeeping,
        renderEditNew: () => (
          <SelectBookkeeping
            value={selectedBookkeeping}
            onChange={setSelectedBookkeeping}
            options={props.bookkeepings}
          />
        )
      }, {
        key: "brand",
        label: RESX.Branding.resxBranding,
        hidden: hasOnlyOneBrand,
        renderEditNew: () => (
          <SelectBrand
            value={selectedBrand}
            onChange={setSelectedBrand}
            options={props.brands}
          />
        )
      }]
    }]}
    submit={onSave}
    redirectToModernPage={redirectToEsign}
  />
}

export default CreateEsign;